import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection  } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { ConfigService } from './services/config.service';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { LOADER_DEFAULTS } from './core/interceptors/loader.tokens';
import { DefaultPreset } from './core/presets/defaultPreset';
import { GlobalErrorHandler } from './core/error/global-error.handler';
import { MessageService } from 'primeng/api';
import { errorInterceptor } from './core/error/global-http-error.interceptor';
import { DialogService } from 'primeng/dynamicdialog';

export function initializeApp() {
  return () => inject(ConfigService).load();
}


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    { provide: LOADER_DEFAULTS, useValue: { showDelayMs: 0, minVisibleMs: 500 } },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(withInterceptors([loadingInterceptor, errorInterceptor])),
    provideAnimationsAsync(),
    MessageService,
    DialogService,
    providePrimeNG({ theme: { preset: DefaultPreset, options: {
      darkModeSelector : '.dark-mode',
    } } }),
    provideAppInitializer(() => {
  const config = inject(ConfigService);
  return config.load();
})

  ]
};
